import * as types from '@/modules/Coupons/store/mutation-types'
import couponsApi from '@/modules/Coupons/api/'
import { rawTimeToLocal } from '@/utils/time';

export const defaultModuleName = 'coupons'
export default {
  namespaced: true,
  state: {
    isLoading: true,
    allCoupons: [],
    companyCoupons: [],
    coupon: null,
    couponAmount: '',
    couponSchedules: []

  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    allCoupons (state) {
      return state.allCoupons
    },
    companyCoupons (state) {
      return state.companyCoupons
    },
    coupon (state) {
      return state.coupon
    },
    couponAmount (state) {
      return state.couponAmount
    },
    couponSchedules (state) {
      return state.couponSchedules
    }
  },
  mutations: {
    [types.IS_LOADING]: (state, status) => {
      return state.isLoading = status
    },
    [types.UPDATE_ALL_COUPONS]: (state, payload) => {
      return state.allCoupons = payload
    },
    [types.UPDATE_COMPANY_COUPONS]: (state, payload) => {
      return state.companyCoupons = payload
    },
    [types.UPDATE_COUPON]: (state, payload) => {
      return state.coupon = payload
    },
    [types.UPDATE_COUPON_AMOUNT]: (state, payload) => {
      return state.couponAmount = payload
    },
    [types.UPDATE_COUPON_SCHEDULES]: (state, payload) => {

      return state.couponSchedules = payload
    }
  },
  actions: {
    async getAllCoupons ({commit}, params) {
      commit(types.IS_LOADING, true)
      try {
        const resp = await couponsApi.getCoupons(params)
        commit(types.UPDATE_ALL_COUPONS, resp.data)
        commit(types.UPDATE_COUPON_AMOUNT, resp.headers['x-total-count'])
      } catch (e) {
        this.$message.error('Ошибка при получении данных о промокодах')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCompanyCoupons ({commit}, payload) {
      let {org_id, params} = payload
      commit(types.IS_LOADING, true)
      try {
        let resp = await couponsApi.getCompanyCoupons(org_id, params)
        const typeMap = {
          'A': 'Акционный',
          'C': 'Корпоративный',
          'X': 'Персональный',
        }
        if (resp.data.length > 0){
          resp.data.map(coupon => {
            coupon.discount = `${coupon.discount}%`
            coupon.type = `${typeMap[coupon.type]}` || 'Неизвестно'
          })
        }
        commit(types.UPDATE_COMPANY_COUPONS, resp.data)
        commit(types.UPDATE_COUPON_AMOUNT, resp.headers['x-total-count'])
      } catch (e) {
        this.$message.error('Ошибка при получении данных о промокодах')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCoupon ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {coupon_id} = payload
        let resp = await couponsApi.getCoupon(coupon_id)
        commit(types.UPDATE_COUPON, resp.data)
      } catch (e) {
        this.$message.error('Ошибка при получении данных о промокоде')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCouponSchedules ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {coupon_id} = payload
        let resp = await couponsApi.getCouponSchedules(coupon_id)
        for (let item of resp.data) {
          if (item['end_time']) {
            item.end_time = rawTimeToLocal(item.end_time)
          }
          if (item['start_time']) {
            item.start_time = rawTimeToLocal(item.start_time)
          }
          if (item['discount']) {
            item.discount = `${item.discount}%`
          }
        }
        commit(types.UPDATE_COUPON_SCHEDULES, resp.data)

      } catch (e) {
        this.$message.error('Ошибка при получении данных о графике промокодов')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCouponSchedule ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {coupon_id, schedule_id} = payload
        let resp = await couponsApi.getCouponSchedule(coupon_id, schedule_id)
        return resp.data
      } catch (e) {
        this.$message.error('Ошибка при получении данных о графике промокода')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCanCompanyUseCoupon ({}, payload) {
      const {org_id} = payload
      const response = await couponsApi.getCanCompanyUseCoupon(org_id)

      return response.data
    },
    async getCouponItems({}, coupon_id){
      return await couponsApi.getCouponItems(coupon_id)
    },

    async postCouponSchedules ({commit, dispatch}, payload) {
      commit(types.IS_LOADING, true)
      let {coupon_id, params} = payload
      let resp = await couponsApi.postCouponSchedules(coupon_id, params)
      await dispatch('getCouponSchedules', {coupon_id})
      commit(types.IS_LOADING, false)

    },
    async postCompanyCoupons ({}, payload) {
      const {org_id, params} = payload
      return await couponsApi.postCompanyCoupons(org_id, params)
    },

    async patchCouponSchedule ({commit, dispatch}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {coupon_id, schedule_id, params} = payload
        await couponsApi.patchCouponSchedule(coupon_id, schedule_id, params)
        await dispatch('getCouponSchedules', {coupon_id})
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async patchCoupon ({}, payload) {
      const {coupon_id, params} = payload
      return await couponsApi.patchCoupon(coupon_id, params)
    },
    async patchCouponItemsServiceCode ({}, payload) {

      const {coupon_id, service_code, params} = payload
      return await couponsApi.patchCouponItemsServiceCode(coupon_id, service_code, params)
    },
    async removeLimitCouponItemsServiceCode ({}, payload) {

      const {coupon_id, service_code} = payload
      return await couponsApi.removeLimitCouponItemsServiceCode(coupon_id, service_code)
    },

    async putCanCompanyUseCoupon ({}, payload) {
      const {org_id} = payload
      const response = await couponsApi.putCanCompanyUseCoupon(org_id)

      return response.data
    },
    async putCouponItemsServiceCode ({}, payload) {
      const {coupon_id, service_code} = payload
      try{
        const response = await couponsApi.putCouponItemsServiceCode(coupon_id,service_code )
        return response.data
      }
      catch (e) {
        throw e
      }

    },

    async deleteCouponSchedule ({commit, dispatch}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {coupon_id, schedule_id} = payload
        await couponsApi.deleteCouponSchedule(coupon_id, schedule_id)
        await dispatch('getCouponSchedules', {coupon_id})
      } catch (e) {
        this.$message.error('Ошибка при удалении данных о графике промокода')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async deleteCoupon ({}, deleteId) {
      return await couponsApi.deleteCoupon(deleteId)
    },
    async deleteCanCompanyUseCoupon ({}, payload) {
      const {org_id} = payload
      const response = await couponsApi.deleteCanCompanyUseCoupon(org_id)

      return response.data
    },
    async deleteCouponItemsServiceCode ({}, payload) {
      const {coupon_id, service_code} = payload
      const response = await couponsApi.deleteCouponItemsServiceCode(coupon_id, service_code)
      return response.data
    },
  }
}
